import { createSlice } from '@reduxjs/toolkit'
import { createAxiosThunk } from 'utils/reduxUtil'
import api from 'api/axios/foka'
import ad from 'api/axios/foka/ad'
import { CampaignTypes } from '../Codes'

const initialState = {
  campaigns: [],
  campaignAdGroups: [],
  targetAdGroupKeywords: [],
  loading: false,
  disabled: false,
  error: false,
}

export const fetchCampaigns = createAxiosThunk(
  'keywordPlanner/fetchCampaigns',
  () => api.ad.getNotDeletedCampaigns()
)

export const fetchCampaignAdGroups = createAxiosThunk(
  'keywordPlanner/fetchCampaignAdGroups',
  campaignId => api.ad.getCampaignNotDeletedAdGroups(campaignId)
)

export const fetchAdGroupKeywords = createAxiosThunk(
  'keywordPlanner/fetchAdGroupKeywords',
  adGroupId => api.ad.getNotDeletedKeywords(adGroupId)
)

export const createKeywords = createAxiosThunk(
  'keywordPlanner/createKeywords',
  createKeywordCommand => ad.addPremiumlinkKeywords(createKeywordCommand)
)

export const addKeywordsSlice = createSlice({
  name: 'keywordPlanner/addKeywords',
  initialState,

  reducers: {
    reset: () => initialState,
  },

  extraReducers: builder => {
    builder.addCase(fetchCampaigns.pending, state => {
      state.loading = true
    })

    builder.addCase(fetchCampaigns.fulfilled, (state, { payload }) => {
      state.campaigns = payload.campaigns.filter(
        campaign => campaign.campaignType === CampaignTypes.PREMIUM_LINK
      )
      state.loading = false
    })

    builder.addCase(fetchCampaigns.rejected, (state, { error, payload }) => {
      state.loading = false
      state.error = payload || error || true
    })

    builder.addCase(fetchCampaignAdGroups.pending, state => {
      state.loading = true
    })

    builder.addCase(fetchCampaignAdGroups.fulfilled, (state, { payload }) => {
      state.campaignAdGroups = payload.adGroupDtos
      state.loading = false
    })

    builder.addCase(
      fetchCampaignAdGroups.rejected,
      (state, { error, payload }) => {
        state.loading = false
        state.error = payload || error || true
      }
    )

    builder.addCase(fetchAdGroupKeywords.pending, state => {
      state.loading = true
    })

    builder.addCase(fetchAdGroupKeywords.fulfilled, (state, { payload }) => {
      state.loading = false
      state.targetAdGroupKeywords = payload.keywordDtos.map(({ id, text }) => ({
        id,
        text,
      }))
    })

    builder.addCase(
      fetchAdGroupKeywords.rejected,
      (state, { error, payload }) => {
        state.loading = false
        state.error = payload || error || true
      }
    )

    builder.addCase(createKeywords.pending, state => {
      state.disabled = true
    })

    builder.addCase(createKeywords.fulfilled, state => {
      state.disabled = false
    })

    builder.addCase(createKeywords.rejected, state => {
      state.disabled = false
    })
  },
})
const { actions, reducer } = addKeywordsSlice
export const { reset } = actions
export default reducer
